import { call, put, takeLatest } from 'redux-saga/effects';
import get from 'lodash.get';

import { userApi } from '../../../api';
import { pushNotification } from '../../ui/actions';
import { getBillingInfo } from '../billing/actions';

import * as actions from './actions';

function* getInfo() {
  try {
    yield put({ type: actions.GET_INFO_PENDING });
    const { data } = yield call(userApi.getInfo);
    const payload = { ...data };
    yield put({ type: actions.GET_INFO_FULFILLED, payload });
  } catch (e) {
    yield put({ type: actions.GET_INFO_REJECTED, payload: e });
  }
}

function* updateInfo({ payload }) {
  try {
    yield put({ type: actions.UPDATE_INFO_PENDING });
    const { status, data } = yield call(userApi.updateInfo, payload);
    if (status === 200) {
      yield put({ type: actions.UPDATE_INFO_FULFILLED, payload: data });
      yield put(
        pushNotification({
          title: 'Your changes have been saved',
          duration: 6,
          type: 'success',
        }),
      );
    }
  } catch (e) {
    const description = get(e, 'message');
    yield put({ type: actions.UPDATE_INFO_REJECTED, payload: e });
    yield put(
      pushNotification({
        title: 'Error updating user details',
        description,
        duration: 6,
        type: 'error',
      }),
    );
  }
}

function* generateApiKey() {
  try {
    yield put({ type: actions.GENERATE_API_KEY_PENDING });
    const { status, data } = yield call(userApi.generateApiKey);

    if (status === 200) {
      yield put({ type: actions.GENERATE_API_KEY_FULFILLED, payload: data });
      yield put(
        pushNotification({
          title: 'New API key generated',
          duration: 6,
          type: 'success',
        }),
      );
    }
  } catch (e) {
    const description = get(e, 'message');
    yield put({ type: actions.GENERATE_API_KEY_REJECTED, payload: e });
    yield put(
      pushNotification({
        title: 'Error generating API key',
        description,
        duration: 6,
        type: 'error',
      }),
    );
  }
}

function* cancelActiveSub() {
  try {
    yield put({ type: actions.CANCEL_ACTIVE_SUB_PENDING });
    const { status } = yield call(userApi.cancelActiveSub);

    if (status === 200) {
      yield call(getInfo);
      yield put(
        pushNotification({
          title: 'Your subscription has been cancelled',
          duration: 6,
          type: 'success',
        }),
      );

      // reload billing
      yield put(getBillingInfo());
    }
  } catch (e) {
    const description = get(e, 'message');
    yield put({ type: actions.CANCEL_ACTIVE_SUB_REJECTED, payload: e });
    yield put(
      pushNotification({
        title: 'Error while canceling your subscription. Please try again',
        description,
        duration: 6,
        type: 'error',
      }),
    );
  }
}

export function* watchGetInfo() {
  yield takeLatest(actions.GET_INFO, getInfo);
}

export function* watchUpdateInfo() {
  yield takeLatest(actions.UPDATE_INFO, updateInfo);
}

export function* watchGenerateApiKey() {
  yield takeLatest(actions.GENERATE_API_KEY, generateApiKey);
}

export function* watchCancelActiveSub() {
  yield takeLatest(actions.CANCEL_ACTIVE_SUB, cancelActiveSub);
}
